import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
   mode:'history',
  //  base:'/',
   scrollBehavior: () => {
      history.pushState(null, null, document.URL)
   },
  routes: [
    {
      path:'/',
      redirect:'./login'
    },
    {
      path: '/login',
      name: 'login',
      component: resolve=>require(['../pages/login/login.vue'],resolve)
    },{
      path: '/404',
      name: 'NotFound',
      component: resolve=>require(['../pages/error/404.vue'],resolve)
    },
    {
      path: '/home',
      name: 'home',
      component: resolve=>require(['../pages/home/home.vue'],resolve),
      children:[
        {
          path:'/index',
          name:'index',
          component: resolve=>require(['../pages/index/index.vue'],resolve)
        },
        {
          path:'/shopList',
          name:'shopList',
          component: resolve=>require(['../pages/shop/shopList.vue'],resolve)
        },
        {
          path:'/roomList',
          name:'roomList',
          component: resolve=>require(['../pages/shop/roomList.vue'],resolve)
        },
        {
          path:'/staffList',
          name:'staffList',
          component: resolve=>require(['../pages/shop/staffList.vue'],resolve)
        },
        {
          path:'/deviceManage',
          name:'deviceManage',
          component: resolve=>require(['../pages/deviceManage/deviceManage.vue'],resolve)
        },
        {
          path:'/orderList',
          name:'orderList',
          component: resolve=>require(['../pages/orderManage/orderList.vue'],resolve)
        },
        {
          path:'/chargeOrderList',
          name:'chargeOrderList',
          component: resolve=>require(['../pages/orderManage/chargeOrderList.vue'],resolve)
        },
        {
          path:'/tuanOrderList',
          name:'tuanOrderList',
          component: resolve=>require(['../pages/orderManage/tuanOrderList.vue'],resolve)
        },
        {
          path:'/cardList',
          name:'cardList',
          component: resolve=>require(['../pages/shop/cardList.vue'],resolve)
        },
        {
          path:'/withdrawList',
          name:'withdrawList',
          component: resolve=>require(['../pages/shop/withdrawList.vue'],resolve)
        },
        {
          path:'/tradeList',
          name:'tradeList',
          component: resolve=>require(['../pages/shop/tradeList.vue'],resolve)
        },

        {
          path:'/mtOrderList',
          name:'mtOrderList',
          component: resolve=>require(['../pages/orderManage/mtOrderList.vue'],resolve)
        },
        {
          path:'/dyOrderList',
          name:'dyOrderList',
          component: resolve=>require(['../pages/orderManage/douOrderList.vue'],resolve)
        }
        ,{
          path:'/promotionList',
          name:'promotionList',
          component: resolve=>require(['../pages/orderManage/promotionList.vue'],resolve)
        },{
          path:'/customerHandle',
          name:'customerHandle',
          component: resolve=>require(['../pages/orderManage/customerHandle.vue'],resolve)
        },
        {
          path:'/deviceDetailList',
          name:'deviceDetailList',
          component: resolve=>require(['../pages/deviceManage/deviceDetailList.vue'],resolve)
        },
        {
          path:'/deviceMap',
          name:'deviceMap',
          component: resolve=>require(['../pages/deviceManage/deviceMap.vue'],resolve)
        },
        {
          path:'/deviceWarehousing',
          name:'deviceWarehousing',
          component: resolve=>require(['../pages/deviceManage/deviceWarehousing.vue'],resolve)
        },
        {
          path:'/dwhFactory',
          name:'dwhFactory',
          component: resolve=>require(['../pages/deviceManage/dwhFactory.vue'],resolve)
        },
        {
          path:'/transferList',
          name:'transferList',
          component: resolve=>require(['../pages/deviceManage/transferList.vue'],resolve)
        },
        {
          path:'/commodityClass',
          name:'commodityClass',
          component: resolve=>require(['../pages/commodityManage/commodityClass.vue'],resolve)
        },
        {
          path:'/commodityList',
          name:'commodityList',
          component: resolve=>require(['../pages/commodityManage/commodityList.vue'],resolve)
        },
        {
          path:'/chooseCommodity',
          name:'chooseCommodity',
          component: resolve=>require(['../pages/commodityManage/chooseCommodity.vue'],resolve)
        },
        {
          path:'/addCommodity',
          name:'addCommodity',
          component: resolve=>require(['../pages/commodityManage/addCommodity.vue'],resolve)
        },
        {
          path:'/organizationList',
          name:'organizationList',
          component: resolve=>require(['../pages/organizationManage/organizationList.vue'],resolve)
        },
        {
          path:'/replenisher',
          name:'replenisher',
          component: resolve=>require(['../pages/organizationManage/replenisher.vue'],resolve)
        },
        {
          path:'/point',
          name:'point',
          component: resolve=>require(['../pages/organizationManage/point.vue'],resolve)
        },
        {
          path:'/agentList',
          name:'agentList',
          component: resolve=>require(['../pages/organizationManage/agentList.vue'],resolve)
        },
        {
          path:'/factory',
          name:'factory',
          component: resolve=>require(['../pages/organizationManage/factory.vue'],resolve)
        },
        {
          path:'/replenishmentRecord',
          name:'replenishmentRecord',
          component: resolve=>require(['../pages/operateManage/replenishmentRecord.vue'],resolve)
        },
        {
          path:'/repSummary',
          name:'repSummary',
          component: resolve=>require(['../pages/operateManage/repSummary.vue'],resolve)
        },
        {
          path:'/salesStatistics',
          name:'salesStatistics',
          component: resolve=>require(['../pages/operateManage/salesStatistics.vue'],resolve)
        },

        {
          path:'/stock',
          name:'stock',
          component: resolve=>require(['../pages/operateManage/stock.vue'],resolve)
        },
        {
          path:'/deviceStock',
          name:'deviceStock',
          component: resolve=>require(['../pages/operateManage/deviceStock.vue'],resolve)
        },
        {
          path:'/deviceStatistics',
          name:'deviceStatistics',
          component: resolve=>require(['../pages/financeManage/deviceStatistics.vue'],resolve)
        },
        {
          path:'/goodsStatistics',
          name:'goodsStatistics',
          component: resolve=>require(['../pages/financeManage/goodsStatistics.vue'],resolve)
        },
        {
          path:'/saleFStatistics',
          name:'saleFStatistics',
          component: resolve=>require(['../pages/financeManage/saleFStatistics.vue'],resolve)
        },
        {
          path:'/settlement',
          name:'settlement',
          component: resolve=>require(['../pages/financeManage/settlement.vue'],resolve)
        },
        {
          path:'/consumerList',
          name:'consumerList',
          component: resolve=>require(['../pages/consumerManage/consumerList.vue'],resolve)
        },
        {
          path:'/joinList',
          name:'joinList',
          component: resolve=>require(['../pages/consumerManage/joinList.vue'],resolve)
        },
        {
          path:'/agent',
          name:'agent',
          component: resolve=>require(['../pages/selfEmployed/agent.vue'],resolve)
        },
        {
          path:'/placeManage',
          name:'placeManage',
          component: resolve=>require(['../pages/selfEmployed/placeManage.vue'],resolve)
        },
        {
          path:'/agent',
          name:'agent',
          component: resolve=>require(['../pages/selfEmployed/agent.vue'],resolve)
        },
        {
          path:'/organization',
          name:'organization',
          component: resolve=>require(['../pages/selfEmployed/organization.vue'],resolve)
        },
        {
          path:'/investorManage',
          name:'investorManage',
          component: resolve=>require(['../pages/shop/investorManage.vue'],resolve)
        },
        {
          path:'/addContract',
          name:'addContract',
          component: resolve=>require(['../pages/shop/addContract.vue'],resolve)
        },{
          path:'/assetManage',
          name:'assetManage',
          component: resolve=>require(['../pages/shop/assetManage.vue'],resolve)
        },
        {
          path:'/editContract',
          name:'editContract',
          component: resolve=>require(['../pages/shop/editContract.vue'],resolve)
        },{
          path:'/contractManage',
          name:'contractManage',
          component: resolve=>require(['../pages/shop/contractManage.vue'],resolve)
        },{
          path:'/deviceList',
          name:'deviceList',
          component: resolve=>require(['../pages/shop/deviceList.vue'],resolve)
        },
        {
          path:'/lockList',
          name:'lockList',
          component: resolve=>require(['../pages/shop/lockList.vue'],resolve)
        },
        {
          path:'/withdrawList',
          name:'withdrawList',
          component: resolve=>require(['../pages/financeManage/withdrawList.vue'],resolve)
        },
        {
          path:'/countStatistics',
          name:'countStatistics',
          component: resolve=>require(['../pages/financeManage/salesStatistics.vue'],resolve)
        },
        {
          path:'/shopStatistics',
          name:'shopStatistics',
          component: resolve=>require(['../pages/financeManage/countStatistics.vue'],resolve)
        }
        ,
        {
          path:'/profitStatistics',
          name:'profitStatistics',
          component: resolve=>require(['../pages/financeManage/profitStatistics.vue'],resolve)
        }
        ,
        {
          path:'/providerIndex',
          name:'providerIndex',
          component: resolve=>require(['../pages/index/providerIndex.vue'],resolve)
        }
        ,
        {
          path:'/pdeviceManage',
          name:'pdeviceManage',
          component: resolve=>require(['../pages/placeprovider/deviceManage.vue'],resolve)
        }
        ,
        {
          path:'/pdeviceMap',
          name:'pdeviceMap',
          component: resolve=>require(['../pages/placeprovider/deviceMap.vue'],resolve)
        }
        ,
        {
          path:'/porderList',
          name:'porderList',
          component: resolve=>require(['../pages/placeprovider/orderList.vue'],resolve)
        }
        ,
        {
          path:'/pgoodsStatistics',
          name:'pgoodsStatistics',
          component: resolve=>require(['../pages/placeprovider/goodsStatistics.vue'],resolve)
        },
        {
          path:'/pdeviceStatistics',
          name:'pdeviceStatistics',
          component: resolve=>require(['../pages/placeprovider/deviceStatistics.vue'],resolve)
        },
        {
          path:'/psaleFStatistics',
          name:'psaleFStatistics',
          component: resolve=>require(['../pages/placeprovider/saleFStatistics.vue'],resolve)
        }
        ,
        {
          path:'/adminDeviceList',
          name:'adminDeviceList',
          component: resolve=>require(['../pages/admin/device/deviceList.vue'],resolve)
        }
        ,
        {
          path:'/adminDeviceMap',
          name:'adminDeviceMap',
          component: resolve=>require(['../pages/admin/device/deviceMap.vue'],resolve)
        }
      ]
    }
  ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js